import React from 'react'
import { connect } from "react-redux";
import { sendAuthentication } from '../../actions/authentication'
import AuthenticationService from '../../services/authentication-service'
import Load from '../../components/load/Load'

class Auth extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }

    componentDidMount() {
        this.sendToken()
    }

    isAuthorized() {
        const isLogged = new AuthenticationService().isLogged
        if (!isLogged && this.props.match.url !== '/authorize') {
            return false
        }
        return true
    }

    async sendToken() {
        if (this.props.match.url === '/authorize') {
            if (this.props.location) {
                if (this.props.location.search) {
                    const params = new URLSearchParams(this.props.location.search)
                    const code = params.get('code')
                    const state = params.get('state')
                    if (code && state) {
                        this.props.sendAuthentication(code, state)
                    } else {
                        console.debug("There aren't code and state")
                    }
                }
            }
        }
    }

    render() {
        return (
            <div className='load-auth'>
                <Load />
                <div className='helper-text'>Realizando autenticação...</div>
            </div>
        )
    }
}

const mapStateToProps = () => ({

});

const mapDispatchToProps = (dispatch) => ({
    sendAuthentication: (code, state) => dispatch(sendAuthentication(code, state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Auth);